var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "shopReviewContent" }, [
    _c("div", { staticClass: "shopReviewContent__container" }, [
      _c("div", { staticClass: "shopRecommended__titleContainer" }, [
        _c("h2", { staticClass: "shopRecommended__title" }, [
          _vm._v(
            _vm._s(_vm.shopName) + "の口コミ(" + _vm._s(_vm.pager.total) + ")"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("h3", { staticClass: "shopReviewContent__heading" }, [
        _vm._v("口コミデータ"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "shopReviews" },
        [
          _c("shop-review-score", {
            attrs: { "shop-reviews": _vm.allShopReviews },
          }),
          _vm._v(" "),
          _vm.shopReviews.length > 0
            ? [
                _c("div", { staticClass: "shopReviews__pagination-count" }, [
                  _vm._v(
                    _vm._s(_vm.pager.offset + 1) +
                      "〜" +
                      _vm._s(_vm.pager.offset + _vm.pager.count) +
                      "件を表示 / 全" +
                      _vm._s(_vm.pager.total) +
                      "件"
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.shopReviews, function (shopReview) {
                  return _c("shop-review", {
                    key: shopReview.id,
                    attrs: { "shop-review": shopReview },
                  })
                }),
                _vm._v(" "),
                _c("front-pagination", {
                  attrs: { pager: _vm.pager, form: _vm.form },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }